import { ca } from '@cian/analytics';
import { PHONE_CODE_SENDER_TO_LABEL } from './constants';
/**
 * Показ блока авторизации
 */

export function trackAuthBlockShown() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'show'
  });
}
/**
 * Успешная авторизация
 */

export function trackAuthenticateSuccess(_ref) {
  var socialType = _ref.socialType,
      senderType = _ref.senderType;
  var label = senderType ? PHONE_CODE_SENDER_TO_LABEL[senderType] : socialType || '';
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'success',
    label: label
  });
}
/**
 * Клик на кнопку "забыли пароль" при авторизации
 */

export function trackForgotPasswordClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'forgot_password_click',
    label: ''
  });
}
/**
 * Успешная отправка формы "забыли пароль"
 */

export function trackForgotPasswordSubmitSuccess() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'get_password',
    label: ''
  });
}
/**
 * Клик на кнопку "забыли пароль" при мердже
 */

export function trackForgotPasswordClickMerge() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'link_accounts_forgot_password',
    label: ''
  });
}
/**
 * Клик по кнопке "хорошо" после запроса ссылки на восстановление
 */

export function trackResetPasswordGotItClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'reset_password_got_it'
  });
}
/**
 * Клик на кнопку "Войти по email или id" или "Войти по телефону"
 * @param {TAuthFlow} flow - flow type
 */

export function trackChangeLoginFlowTo(flow) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: flow === 'email' ? 'login_email_ID' : 'login_phone'
  });
}
/**
 * Переход на шаг ввода пароля при пошаговой форме
 */

export function trackShowTwoStepPassword(element) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'get_password_input',
    label: element
  });
}
/**
 * Переход на шаг ввода пароля при пошаговой форме для нового пользователя
 */

export function trackShowTwoStepPasswordRegistration() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'make_new_password_input'
  });
}
/**
 * Клик на кнопку прололжить в форме пошаговой авторизации
 */

export function trackLoginResumeButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'email_continue'
  });
}
/**
 * Клик по ссылке нужана помощь для флоу авторизации/регистрации по email/id
 */

export function trackLoginNeedHelp() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'email_cant_confirm'
  });
}
/**
 * Клик на кнопку "Выбрать другой аккаунт"
 */

export function trackLoginAnotherWay() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'login_another_way'
  });
}